module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-UltLt.97684b08.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/AvenirNextLTPro-UltLt.svg
// module id = 231
// module chunks = 0